import { Slice } from "./summaryCountSlice";

const { actions } = Slice;

export const setNoticeSummary = (queryParams: any) => (
  dispatch: (arg0: { payload: any; type: string }) => void
) => {
  // dispatch(actions.startCall({ callType: callTypes.list }));
  return dispatch(actions.summarySet(queryParams));
};
